// extracted by mini-css-extract-plugin
export default {"layout":"layout_p0bY3","sider":"sider_gpYyN","content":"content_ZC_bQ","verifyModal":"verifyModal_CkJiI","verifyImage":"verifyImage_CGjkg"};